import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { environment } from 'src/environments/environment';
// fetch('/assets/config.json')
//   .then(resp => resp.json())
//   .then(config => {
//     if (config.production) {
//       enableProdMode();
//     }
//     const appInjector = platformBrowserDynamic([
//       { provide: 'APP_CONFIG', useValue: config }
//     ]);

//     appInjector.bootstrapModule(AppModule)
//       .catch(err => console.error(err));
//   });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));